module.exports = __webpack_public_path__ + "img/dordrecht5d@2x.29f98a67.jpg";